var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-page"},[(!_vm.isLoggedIn)?_c('div',{staticClass:"login-container"},[_c('LoginSign',{on:{"login-success":_vm.handleLoginSuccess}})],1):_c('div',{staticClass:"qrcode-container"},[_c('DynamicQrcodeDisplay',{attrs:{"sign-info":_vm.signInfo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }